import { forwardRef, type ReactNode } from "react"
import { ListItemIcon, MenuItem, Typography, type MenuItemProps } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { makeStyles } from "tss-react/mui"

type StyleProps = Readonly<{
    textColor?: string
    hoverBackgroundColor?: string
}>

const useStyles = makeStyles<StyleProps>()((theme, { textColor, hoverBackgroundColor }) => ({
    root: {
        "&.MuiMenuItem-root": {
            minHeight: "auto",
            padding: ".5rem 1rem",
            color: textColor,
        },
        "&.MuiMenuItem-root:hover": {
            backgroundColor: hoverBackgroundColor,
        },
    },
    icon: {
        "&.MuiListItemIcon-root": {
            minWidth: "1.75rem",
            color: textColor ?? theme.palette.tailwind.slate[500],
        },
        "& svg": {
            fontSize: ".875rem",
        },
    },
}))

type Props = Readonly<{
    icon?: IconDefinition
    textColor?: string
    hoverBackgroundColor?: string
    children: ReactNode
}> &
    MenuItemProps

export const StandardMenuItem = forwardRef<HTMLLIElement, Props>(function StandardMenuItem(
    { icon, textColor, hoverBackgroundColor, className, children, ...menuItemProps },
    ref,
) {
    const { classes, cx } = useStyles({ textColor, hoverBackgroundColor })

    return (
        <MenuItem ref={ref} {...menuItemProps} className={cx(classes.root, className)}>
            {icon && (
                <ListItemIcon className={classes.icon}>
                    <FontAwesomeIcon icon={icon} />
                </ListItemIcon>
            )}
            <Typography variant="body2" component="span">
                {children}
            </Typography>
        </MenuItem>
    )
})
